import type { SupportCategory } from "@/v2-components/pages/support/types/support-data";

/*
categorySlug 가 현재 node 에 포함되있는지 판단
 */
export const isNodeInPath = (
  node: SupportCategory,
  categorySlug: string | string[],
): boolean => {
  if (!node.children || node.children.length === 0) return false;
  return node.children.some(
    (child) => child.id === categorySlug || isNodeInPath(child, categorySlug),
  );
};
